const CONFIG = {
  REACT_APP_GOOGLE_MAPS_API_KEY: 'AIzaSyCoBGt0Sb5oTB1JjnWdXFTuj9jiyKoghzc',
  REACT_APP_STRIPE_API_KEY: 'pk_test_Q90biNAgSg4brplOP0o6q4qr',
  REACT_APP_STRIPE_CLIENT_ID: 'ca_Bqfbp8ay4JEhrBojFyv4UyHr4g8cMkrA'
}

export default CONFIG



// WEBPACK FOOTER //
// ./src/modules/config/default.js